import { DocumentType } from "./documents";

export interface DocumentTemplate {
  language: string;
  documentTemplate: string;
  document?: string;
}

export interface DocumentStatus {
  name: string;
  code: string;
}

export interface DocumentDetailsRecord {
  _id?: string;
  orderId: string;
  documentId: string;
  type: DocumentType;
  fieldValues: Record<string, string | number | boolean | null>;
  flexibleFields?: string[];
  templates?: DocumentTemplate[];
  status?: DocumentStatus;
}

export interface DocumentDetailsQuery {
  _id?: string;
  orderId?: string;
  documentId?: string;
  type?: DocumentType;
}

export interface GenerateDocumentDetailsPdfPayload {
  orderId: string;
  type: DocumentType;
  primaryLanguage: string;
  includeDualLanguage?: boolean;
  secondaryLanguage?: string;
}

/**
 * Funkcja pomocnicza do pobierania szablonu dla konkretnego języka.
 * @since 13.07.2026
 */
export function getTemplateForLanguage(
  templates: DocumentTemplate[] | undefined,
  language: string,
): DocumentTemplate | undefined {
  if (!templates) {
    return undefined;
  }
  console.log(templates);
  console.log(language);
  return templates.find(
    (t) => t.language.toLowerCase() === language.toLowerCase(),
  );
}

/**
 * Funkcja pomocnicza do aktualizacji szablonu dla konkretnego języka.
 * @since 13.07.2026
 */
export function upsertTemplateForLanguage(
  templates: DocumentTemplate[],
  template: DocumentTemplate,
): DocumentTemplate[] {
  const existingIndex = templates.findIndex(
    (t) => t.language.toLowerCase() === template.language.toLowerCase(),
  );

  if (existingIndex >= 0) {
    templates[existingIndex] = { ...templates[existingIndex], ...template };
  } else {
    templates.push(template);
  }

  return templates;
}
